import React, { Component } from 'react'
import cn from 'classnames'
import utils from '../../lib/utils'
import Files from './Files'
import Loading from '../Loading'

export default class Images extends Component {
  isComplete (file) {
    return (!file.status && !file.error) || file.status === 'Complete'
  }

  onRemove (file, e) {
    this.refs.files.decoratedComponentInstance.onRemove(file, e)
  }

  renderFile = file => {
    return <li key={file.key || file.name} className={cn('image-item', {error: !!file.error})}>
      {file.loading && <Loading />}
      <div>
        <span className='upload-status'>{file.status || ''}</span>
        <span className='upload-error'>{file.error || ''}</span>
        {this.isComplete(file) && <img src={utils.fileUrl(file)} />}
        <button className='ion-ios-close-empty' onClick={this.onRemove.bind(this, file)} />
      </div>
    </li>
  }

  render () {
    return <Files {...this.props}
      ref='files' renderFile={this.renderFile}
      labels={{one: 'an image', multiple: 'images', upload: 'Pick or drop'}}
    />
  }
}



// WEBPACK FOOTER //
// ./app/components/fields/Images.js